// src/components/ReportTable.tsx
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Column<T> {
  header: string;
  // accessor: keyof T | ((data: T) => React.ReactNode);
  accessor: any;
  className?: string; // Tailwind CSS classes for cell
  headerClassName?: string; // Tailwind CSS classes for header cell
}

interface ReportTableProps<T> {
  columns: Column<T>[];
  data: T[];
  columnWidths?: string[]; // Optional widths for each column
}

const ReportTable = <T extends object>({ columns, data, columnWidths }: ReportTableProps<T>) => {
  if (!data || data.length === 0) {
    return <p className="text-gray-500 text-center py-4">No data to display.</p>;
  }

  return (
    <div className="w-full overflow-x-auto overflow-y-auto rounded-lg shadow-sm border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        {columnWidths && (
          <colgroup>
            {columnWidths?.map((width, idx) => (
              <col key={idx} style={{ width }} />
            ))}
          </colgroup>
        )}
        <thead className="bg-gray-50">
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                scope="col"
                // className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${column.headerClassName || ''}`}
                className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${column.headerClassName || ''}`}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              {columns.map((column, colIndex) => (
                <td
                  key={colIndex}
                  className={`px-6 py-4 text-sm text-gray-900 ${column.className || ''}`}
                >
                  {typeof column.accessor === 'function'
                    ? column.accessor(row)
                    : (row[column.accessor as keyof T] as React.ReactNode)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
